<template>
  <span
    v-if="pendingReviews.length > 0"
    class="notification-badge"
    :aria-label="
      $i18n.$t('You have {count} messages.', { count: pendingReviews.length })
    "
    >{{ pendingReviews.length }}</span
  >
</template>

<script setup lang="ts">
const reviewsStore = useReviewsStore()
const { pendingReviews } = storeToRefs(reviewsStore)
const { $i18n } = useNuxtApp()
</script>

<style scoped>
.notification-badge {
  background: var(--colour-red);
  color: white;
  border-radius: 50%;
  min-width: 1.35em;
  min-height: 1.35em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6em;
  font-weight: bold;
  line-height: 1;
  z-index: 1;
  aspect-ratio: 1;
}
</style>
